<template>
  <div class="navMenu">
    <div class="navMenuLeft"></div>
    <div class="navMenuRight">
      <div class="rightTop"></div>
      <div class="rightBottom"></div>
    </div>
    <div class="navContent">
      <div class="content_area">
        <div class="logo">
          <img
            :src="menuLogo"
            class="cursor"
            :alt="$t('siffa')"
            @click="$router.push('/')"
          />
        </div>
        <div class="topHeader">
          <div class="language">
            <changeLocale></changeLocale>
          </div>
          <div class="topMenu">
            <div class="fr clearfix topSearch">
              <div class="fl">
                <!-- <el-input size="mini" v-model="searchVal">
                  <i
                    slot="suffix"
                    class="el-icon-search cursor"
                    style="margin-right: 5px"
                    @click="searchContent"
                  ></i>
                </el-input> -->
                <el-autocomplete
                  size="mini"
                  v-model="searchVal"
                  :fetch-suggestions="querySearchCompanyName"
                  :placeholder="$t('entercontent')"
                  :trigger-on-focus="false"
                >
                  <i
                    slot="suffix"
                    class="el-icon-search cursor"
                    style="margin-right: 5px"
                    @click="searchContent"
                  ></i
                ></el-autocomplete>

                <!-- <searchCompany v-model="searchVal" @search="searchContent"></searchCompany> -->
              </div>
              <div class="fl routerLink">
                <span>{{ $t("welcomeyou") }}！ </span>
                <span v-if="!IS_LOGIN">
                  <router-link to="/sign" class="goLogin">
                    <span>{{ $t("sign") }}</span> </router-link
                  >｜
                  <router-link to="/signUp" class="goLogin">
                    <span>{{ $t("signup1") }}</span>
                  </router-link>
                </span>
                <span v-else>
                  <el-popover
                    placement="bottom-start"
                    trigger="click"
                    v-model="visible"
                  >
                    <div class="navMenuselfAccountInfo">
                      <p class="textOverflow">
                        {{ $t("name") }}：{{
                          USER_INFO.name_en
                            | priorFormat(USER_INFO.name_zh, LOCALE)
                        }}
                      </p>
                      <p class="textOverflow">
                        {{ $t("position") }}：{{
                          USER_INFO.job_title_en
                            | priorFormat(USER_INFO.job_title_zh, LOCALE)
                        }}
                      </p>
                      <p class="textOverflow">
                        {{ $t("email") }}：{{ USER_INFO.email | textFormat }}
                      </p>
                      <p class="textOverflow">
                        {{ $t("phone") }}：{{ USER_INFO.mobile | textFormat }}
                      </p>
                    </div>

                    <div class="navMenuselfAccountInfoBtn">
                      <el-button
                        type="danger"
                        size="small"
                        @click="
                          visible = false;
                          logOut();
                        "
                        >{{ $t("logout") }}</el-button
                      >
                    </div>
                    <img
                      :src="USER_INFO.avatar || defaultAvatar"
                      :alt="$t('siffa')"
                      class="userAvatar cursor"
                      slot="reference"
                    />
                  </el-popover>
                  <router-link to="/console/account/userInfo">{{
                    $t("console")
                  }}</router-link>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="navMenuLink">
          <div class="content_area clearfix">
            <div class="fr meau">
              <el-menu
                class="el-menu-atf"
                mode="horizontal"
                :default-active="activeIndex"
                menu-trigger="click"
                @select="selectMenu"
              >
                <el-menu-item index="/">{{ $t("websiteIndex") }}</el-menu-item>
                <el-menu-item index="/survey">{{
                  $t("profileAssociation")
                }}</el-menu-item>
                <el-submenu index="/2">
                  <template slot="title">{{ $t("memberList") }}</template>
                  <el-menu-item index="/companyCatalog">{{
                    $t("companyList")
                  }}</el-menu-item>
                  <el-menu-item index="/companyContactList">{{
                    $t("concatList")
                  }}</el-menu-item>
                </el-submenu>
                <el-menu-item index="/overseas">{{
                  $t("Directoverseas ")
                }}</el-menu-item>
                <el-menu-item index="">{{ $t("meetingCenter") }}</el-menu-item>
                <!-- <el-menu-item index="">
                  <a href="https://www.ailajob.com" target="_blank" @click.stop
                    >校企合作</a
                  >
                </el-menu-item> -->
                <el-submenu index="/talents">
                  <template slot="title">{{ $t("talentZone") }}</template>
                  <el-menu-item index="/talents/recruitment">{{
                    $t("informationInfo")
                  }}</el-menu-item>
                  <el-menu-item index="/talents/library">{{
                    $t("talentZone1")
                  }}</el-menu-item>
                </el-submenu>
                <el-menu-item index="/education_index">{{
                  $t("educationalTrain")
                }}</el-menu-item>
                <!-- <el-menu-item index="/companyServe">企业合规中心</el-menu-item> -->
                <el-menu-item index="/contactUs">党建服务</el-menu-item>
              </el-menu>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :title="$t('tipsTitle')"
      :visible.sync="dialogVisible"
      width="300px"
      :close-on-click-modal="true"
    >
      <div class="tc openDialog">{{$t('Notyetopen')}}</div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span> -->
    </el-dialog>
    <el-dialog
      :title="$t('tipsTitle')"
      :visible.sync="isMumber"
      width="300px"
      :close-on-click-modal="true"
    >
      <div class="tc openDialogs">
        <span class="blue" @click="goToMember">{{$t('vipBecome')}}</span>,{{$t('UnlockRights')}}
      </div>
    </el-dialog>
  </div>
</template>

<script>
import searchCompany from "~sif/components/company/unit/searchCompany";
import changeLocale from "~/baseComponents/changeLocale";

export default {
  components: { searchCompany, changeLocale },
  data() {
    return {
      isMumber: false,
      visible: false,
      defaultAvatar:
        "https://attached-file.oss-cn-shanghai.aliyuncs.com/ailaworldImgs/siffa/headportrait.png",
      activeIndex: "/",
      menuLogo:
        "https://attached-file.oss-cn-shanghai.aliyuncs.com/ailaworldImgs/siffa/menuLogo.png",
      searchVal: "",
      zhReg: /^[\u4e00-\u9fa5]+$/i,
      dialogVisible: false,
    };
  },
  methods: {
    logOut() {
      this.$store.commit("baseStore/CLEAR_USER_INFO");
      this.$router.push("/sign");
    },
    // 搜索框
    searchContent() {
      if (this.searchVal) {
        this.$router.push({
          path: "/companyCatalog",
          query: {
            parameter: this._encode({
              searchVal: this.searchVal,
            }),
          },
        });
      } else {
        this.$router.push("/companyCatalog");
      }
    },
    async querySearchCompanyName(queryString, cb) {
      let params = {};
      params.company_name = queryString;
      params.source = this.PJSource;
      params.usage = 2;
      params.is_vip = 1;
      let res = await this.$store.dispatch(
        "baseStore/company_associateSearch",
        params
      );
      let values;
      if (this.zhReg.test(queryString)) {
        values = res.data.map((item) => {
          item.value = item.name_zh;
          return item;
        });
      } else {
        // 输入是英文或者是数字
        values = res.data.map((item) => {
          if (item.name_en) {
            // 返回数据中，英文有值
            item.value = item.name_en;
          } else {
            item.value = item.name_zh;
          }
          return item;
        });
      }
      cb(values);
    },
    handleActive(path) {
      if (path.indexOf("survey") != -1) {
        this.activeIndex = path.substring(0, 7);
      } else {
        this.activeIndex = path;
      }
    },
    selectMenu(index, path) {
      if (index.indexOf("http") !== -1) {
        window.open(index);
        return;
      }
      if (index === "/talents/library") {
        if (!this.USER_INFO || !this.USER_INFO.aila_no) {
          this.isMumber = true;
          return;
        }
      }
      if (index == "") {
        this.dialogVisible = true;
        return;
      }
      this.$router.push(index);
    },
    goToMember() {
      this.isMumber = false;
      this.$router.push("/memberShip");
    },
  },
  watch: {
    $route(nv) {
      this.handleActive(nv.path);
      // if (this.$route.query.parameter) {
      //   this.searchVal = this._decode(nv.query.parameter).searchVal;
      // } else {
      //   this.searchVal = "";
      // }
    },
  },
  mounted() {},
};
</script>

<style scoped lang="less">
.navMenu {
  .userAvatar {
    width: 30px;
    height: 30px;
    margin-right: 10px;
    border-radius: 15px;
  }
  height: 100px;
  width: 100%;
  position: relative;
  .navMenuLeft {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 50%;
    height: 100px;
    background: #fff;
  }
  .navMenuRight {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 50%;
    height: 100px;
    .rightTop {
      height: 40px;
      // background: #fff6f6;
      background: #fff;
    }
    .rightBottom {
      height: 60px;
      // background: #ff5155;
      background: linear-gradient(180deg, #E7C493, #F7E9BD);
    }
  }
  .navContent {
    width: 100%;
    height: 100px;
    position: absolute;
    top: 0px;
    left: 0px;
    .content_area {
      width: 1250px;
      position: relative;
      .logo {
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 5;
      }
    }
    .topSearch {
      line-height: 40px;
      .routerLink {
        margin-left: 32px;
      }
      .iconSearch {
        margin-right: 5px;
      }
    }
  }
  .topHeader {
    height: 40px;
    // background: #fff6f6;
    background: #fff;
    overflow: hidden;
  }
  .navMenuLink {
    height: 60px;
    // background: #ff5155;
    background: linear-gradient(180deg, #E7C493, #F7E9BD);
  }
}
.userImg {
  margin-right: 10px;
  img {
    width: 26px;
    height: 26px;
    border-radius: 50%;
  }
}
.goLogin {
  color: #666;
}
/deep/.el-input--mini .el-input__inner {
  border-radius: 15px;
}
.openDialog {
  height: 100px;
  line-height: 100px;
}
/**
导航条的样式
*/
.el-menu-atf {
  border-bottom: none;
}
.el-menu {
  background: transparent;
}
.submenu {
  width: 110px;
}
/deep/.el-menu-item {
  background-color: transparent !important;
  // color: #fea2a4 !important;
  font-size: 16px;
  color: #9C6F23 !important;
}
/deep/.el-menu-item:hover {
  outline: 0 !important;
  // color: #fff !important;
  color: #E42F42 !important;
}
/deep/.el-menu-item.is-active {
  // color: #fff !important;
  color: #E42F42 !important;
  background: transparent !important;
}
/deep/.el-menu--horizontal > .el-submenu .el-submenu__title,
.el-menu--horizontal > .el-menu-item {
  border-bottom: none;
  &.is-active {
    // color: #fff;
    color: #E42F42;
    border-bottom: 0;
    background: transparent;
  }
}
/deep/.el-menu--horizontal > .el-submenu {
  .el-submenu__title {
    // color: #fea2a4 !important;
    font-size: 16px;
    color: #9C6F23 !important;
    border-bottom: none !important;
    i {
      // color: #fea2a4;
      font-size: 16px;
      color: #9C6F23 !important;
    }
    &:hover {
      background: transparent;
      // color: #fff !important;
      color: #f45b5b !important;

    }
  }
}
/deep/.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  // color: #fff !important;
  color: #f45b5b !important;
}
.el-menu--horizontal .el-menu .el-menu-item.is-active,
.el-menu--horizontal .el-menu .el-submenu.is-active > .el-submenu__title {
  background: #fef7f7 !important;
  color: #f45b5b;
}
/deep/.el-menu.el-menu--horizontal {
  border-bottom: none;
}
</style>
<style lang="less">
.el-menu--collapse .el-menu .el-submenu,
.el-menu--popup {
  min-width: 110px !important;
  text-align: center;
}
.navMenuselfAccountInfo {
  p {
    line-height: 28px;
  }
  .navMenuselfAccountInfoBtn {
    margin-top: 8px;
  }
}
.blue {
  color: #409eff;
  cursor: pointer;
}
.openDialogs {
  height: 100px;
  line-height: 100px;
}
.language {
  position: relative;
  z-index: 10;
  float: right;
  width: 60px;
  height: 40px;
  margin-left: 20px;
  line-height: 40px;
  /deep/ .el-dropdown {
    span {
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
    }
  }
}
</style>
